import cn from 'classnames';
import { Tab as ReakitTab, TabOptions } from 'reakit/Tab';

import styles from './Tab.module.css';

interface TabProps {
  activeColor: string;
  children: string;
  id: string;
  tab: TabOptions;
  className?: string;
}

export default function Tab({
  activeColor,
  children,
  tab,
  id,
  className,
}: TabProps) {
  const isActive = tab.selectedId === id;

  return (
    <ReakitTab
      {...tab}
      id={id}
      className={cn(
        `focus:outline-none relative inline-block pb-3 text-sm font-medium uppercase tracking-wide`,
        isActive ? styles.tab : null,
        isActive ? activeColor : null,
        className,
      )}
    >
      {children}
    </ReakitTab>
  );
}
